import { ChangeEvent, useEffect } from 'react'
import { Badge, HStack, Stack } from '@chakra-ui/react'

import { MaskedInput } from 'components'
import { brazilianDateMask } from 'utils/masks'
import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'
import { getTodayOnStringFormat } from 'utils/transforms/date'
import validateDateOnCustomForm from 'components/tools/CustomForm/components/Viewer/utils/validateDateOnCustomForm'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import useCustomFormGetDefaultValue from '../../hooks/useCustomFormGetDefaultValue'

export default function CustomFormDateQuestion({
  question,
  questionKey,
  disabled,
  formMethods,
}: CustomFormViewerQuestionProps) {
  const { removeErrorFromQuestion, setErrorOnQuestion, thisQuestionHasError } = useCustomFormViewer()

  const { defaultValue } = useCustomFormGetDefaultValue({ question, questionKey, disabled })

  const questionWithError = thisQuestionHasError(question.slug)?.question

  function setInputErrorMessageOnQuestion(date: string) {
    const errorMessage = validateDateOnCustomForm({ date, question })
    if (errorMessage === '') {
      removeErrorFromQuestion(question.slug)
    } else {
      setErrorOnQuestion(question, errorMessage)
    }
  }

  function handleOnBlur(event: ChangeEvent<HTMLInputElement>) {
    const inputValue = event.target.value
    setInputErrorMessageOnQuestion(inputValue)
  }

  useEffect(() => {
    if (defaultValue) {
      setInputErrorMessageOnQuestion(defaultValue)
    }
    if (formMethods?.setValue) {
      formMethods.setValue(questionKey, defaultValue)
    }
  }, [defaultValue])

  return (
    <Stack>
      <MaskedInput
        id={question.slug}
        isDisabled={disabled}
        mask={brazilianDateMask}
        placeholder={question?.placeholder}
        value={formMethods?.watch ? formMethods.watch(questionKey) : defaultValue}
        {...(formMethods?.register && formMethods.register(questionKey, { onBlur: handleOnBlur }))}
      />

      {question.validation && (
        <HStack flexWrap="wrap">
          {question.validation.date_must_be_later && (
            <Badge textTransform="none">Data posterior a hoje ({getTodayOnStringFormat()})</Badge>
          )}
          {question.validation.date_must_be_previous && (
            <Badge textTransform="none">Data anterior a hoje ({getTodayOnStringFormat()})</Badge>
          )}
          {question.validation.date_must_be_this_week_days &&
            question.validation.date_must_be_this_week_days.length > 0 && (
              <Badge textTransform="none">
                Dias da semana permitidos: ({question.validation.date_must_be_this_week_days.join(', ')})
              </Badge>
            )}
        </HStack>
      )}

      <CustomFormFieldErrorMessage message={questionWithError?.error_message} />
    </Stack>
  )
}
